import type { FinanceInfo } from '@carvana/merch-contracts';
import { FinanceInfoFromApi } from '~/services/common/contracts';

export default function formatFinanceInfo(
  financeInfo: FinanceInfoFromApi
): FinanceInfo {
  return {
    ...financeInfo,
    minDownPaymentNoTrade: financeInfo.minDownPaymentNoTrade ?? undefined
  };
}
